<script>
import VueDropify from "vue-dropify";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import Axios from "axios";

// Custom Components and variables OR method
import { authComputed, authMethods } from "@/state/helpers";
import {
  currency,
  time_zones,
  date_formate,
  time_formate,
  date_time_formate,
} from "@/helpers/global.variable";
import Middleware from "@/helpers/middlewares";
import hotelService from "@/helpers/APIService/hotel.service";

export default {
  components: {
    VueDropify,
    VueCropper,
    DatePicker,
  },
  data() {
    return {
      vueTelInputProps: {
        dropdownOptions: {
          showDialCodeInSelection: true,
        },
      },
      hotel_fields: {
        check_in_time: moment().format("HH:mm"),
        check_out_time: moment().format("HH:mm"),
        early_check_in_time: moment().format("HH:mm"),
        late_check_out_time: moment().format("HH:mm"),
      },
      website: "",
      rewards_website_url: "",
      rewards_website_join_url: "",
      phone_number_iso: "US",
      front_desk_number_iso: "US",
      whatsapp_number_iso: "US",
      sms_number_iso: "US",
      phone_number_code: "+1 ",
      front_desk_number_code: "+1 ",
      whatsapp_number_code: "+1 ",
      sms_number_code: "+1 ",
      submitted: false,
      time_zone: [],
      isLoading: true,
      isBtnLoading: false,
      date_formate,
      time_formate,
      date_time_formate,
      currency,
      time_zones,
      time: null,
      isError: false,
      errorMessage: "",
      format: "HH:mm",
      logo: {
        file: null,
        url: "",
        imgURL: "",
      },
      favicon_icon: {
        file: null,
        url: "",
        imgURL: "",
      },
    };
  },
  computed: {
    ...authComputed,
  },
  async mounted() {
    await this.getHotel();
  },
  methods: {
    ...authMethods,
    // copyCode
    copyCode(code) {
      Middleware.copyCode(code);
    },
    // Method is use for get hotel details
    getHotel() {
      hotelService.getHotelDetails().then((response) => {
        this.hotel_fields = response;
        this.phone_number_iso = response.phone_number_iso;
        let phone_number = this.managePhoneNumber(response.phone_number);

        this.front_desk_number_iso = response.front_desk_number_iso;
        let front_desk_number = this.managePhoneNumber(
          response.front_desk_number
        );

        this.whatsapp_number_iso = response.whatsapp_number_iso;
        let whatsapp_number = this.managePhoneNumber(response.whatsapp_number);

        this.sms_number_iso = response.sms_number_iso;
        let sms_number = this.managePhoneNumber(response.sms_number);

        let date_format =
          response.date_format != null ? response.date_format : "MMM-DD-YYYY";
        let time_format =
          response.time_formate !== null ? response.time_formate : "HH:MM:SS";
        let date_time_format =
          response.date_time_format !== null
            ? response.date_time_format
            : "MM-DD-YYYY HH:MM:SS";

        this.logo.url = response.logo !== null ? response.logo : "";
        this.favicon_icon.url =
          response.favicon_icon !== null ? response.favicon_icon : "";
        const rewards_website_join_url =
          response.brand.rewards_website_join_url;
        const rewards_website_url = response.rewards_website_url;
        const brand = response.brand.name;
        this.hotel_fields = {
          ...this.hotel_fields,
          phone_number,
          front_desk_number,
          whatsapp_number,
          sms_number,
          date_format,
          time_format,
          date_time_format,
          rewards_website_join_url,
          rewards_website_url,
          brand,
        };
        this.isLoading = false;
      });
    },
    // Method is use for submit updated hotel details
    onSubmit() {
      this.isBtnLoading = true;
      this.isError = false;

      let hotelData = new FormData();
      hotelData.append("name", this.hotel_fields.name);
      hotelData.append("email", this.hotel_fields.email);
      hotelData.append("currency", this.hotel_fields.currency);
      hotelData.append("time_zone", this.hotel_fields.time_zone);
      hotelData.append("check_in_time", this.hotel_fields.check_in_time);
      hotelData.append("check_out_time", this.hotel_fields.check_out_time);
      hotelData.append("city", this.hotel_fields.city);
      hotelData.append("state", this.hotel_fields.state);
      hotelData.append("country", this.hotel_fields.country);
      hotelData.append("zip_code", this.hotel_fields.zip_code);
      hotelData.append("address", this.hotel_fields.address);
      hotelData.append("website", this.hotel_fields.website);
      hotelData.append(
        "early_check_in_time",
        this.hotel_fields.early_check_in_time
      );
      hotelData.append(
        "late_check_out_time",
        this.hotel_fields.late_check_out_time
      );

      // Phone number store related conditions
      if (this.hotel_fields.phone_number !== "") {
        hotelData.append(
          "phone_number",
          this.phone_number_code + this.hotel_fields.phone_number
        );
        hotelData.append("phone_number_iso", this.phone_number_iso);
      } else {
        hotelData.append("phone_number", this.hotel_fields.phone_number);
        hotelData.append("phone_number_iso", "US");
      }
      // Front desk number related conditions
      if (this.hotel_fields.front_desk_number !== "") {
        hotelData.append("front_desk_number_iso", this.front_desk_number_iso);
        hotelData.append(
          "front_desk_number",
          this.front_desk_number_code + this.hotel_fields.front_desk_number
        );
      } else {
        hotelData.append(
          "front_desk_number",
          this.hotel_fields.front_desk_number
        );
        hotelData.append("front_desk_number_iso", "US");
      }
      // Whatsapp number related conditions
      if (this.hotel_fields.whatsapp_number !== "") {
        hotelData.append(
          "whatsapp_number",
          this.whatsapp_number_code + this.hotel_fields.whatsapp_number
        );
        hotelData.append("whatsapp_number_iso", this.whatsapp_number_iso);
      } else {
        hotelData.append("whatsapp_number", this.hotel_fields.whatsapp_number);
        hotelData.append("whatsapp_number_iso", "US");
      }
      if (this.logo.file != null || "") {
        hotelData.append(
          "logo",
          this.createImageFromBase(
            this.$refs.cropper.getCroppedCanvas().toDataURL(),
            "logo.jpg"
          )
        );
      }
      if (this.favicon_icon.file != null || "") {
        hotelData.append(
          "favicon_icon",
          this.createImageFromBase(
            this.$refs.cropper.getCroppedCanvas().toDataURL(),
            "favicon_icon.jpg"
          )
        );
      }
      hotelData.append("app_theme_color", this.hotel_fields.app_theme_color);
      if (this.hotel_fields.date_format == "undefined") {
        hotelData.append("date_format", "MMM-DD-YYYY");
      } else {
        hotelData.append("date_format", this.hotel_fields.date_format);
      }
      if (this.hotel_fields.time_format == "undefined") {
        hotelData.append("time_format", "HH:MM:SS");
      } else {
        hotelData.append("time_format", this.hotel_fields.time_format);
      }
      if (this.hotel_fields.date_time_format == "undefined") {
        hotelData.append("date_time_format", "HH:MM:SS");
      } else {
        hotelData.append(
          "date_time_format",
          this.hotel_fields.date_time_format
        );
      }
      hotelService
        .updateHotelDetails(hotelData)
        .then((response) => {
          this.isBtnLoading = false;
          Middleware.notification("Successfully updated !!", "success");
          this.setHotel().then(() => {
            this.$router.go();
            this.logo.file = null;
            this.favicon_icon.file = null;
            this.submitted = false;
          });
        })
        .catch((error) => {
          this.isError = true;
          this.isBtnLoading = false;
          this.errorMessage = error.response.data;
          Middleware.notification("Something went wrong !!", "danger");
        });
    },
    // Method is use for update and maintained favicon icon
    changeFavicon(event) {
      if (event[0] !== undefined) {
        this.favicon_icon.file = event[0] == undefined ? null : event[0];
        this.favicon_icon.imgURL = URL.createObjectURL(event[0]);
      } else {
        this.favicon_icon.file = null;
        this.favicon_icon.url = "";
        this.favicon_icon.imgURL = "";
      }
    },
    // Method is use for update and maintained logo icon
    changeLogo(event) {
      if (event[0] !== undefined) {
        this.logo.file = event[0] == undefined ? null : event[0];
        this.logo.imgURL = URL.createObjectURL(event[0]);
      } else {
        this.logo.file = null;
        this.logo.url = "";
        this.logo.imgURL = "";
      }
    },
    // Method is use for maintained and mange country change
    countryChange(phone_type, code) {
      switch (phone_type) {
        case "phone_number":
          this.phone_number_iso = code.iso2;
          this.phone_number_code = "+" + code.dialCode + " ";
          break;
        case "front_desk_number":
          this.front_desk_number_iso = code.iso2;
          this.front_desk_number_code = "+" + code.dialCode + " ";
          break;
        case "whatsapp_number":
          this.whatsapp_number_iso = code.iso2;
          this.whatsapp_number_code = "+" + code.dialCode + " ";
          break;
        case "sms_number":
          this.sms_number_iso = code.iso2;
          this.sms_number_code = "+" + code.dialCode + " ";
          break;
      }
    },
    // Method is used to manage phone number
    managePhoneNumber(number) {
      return number !== null
        ? number.trim().substring(number.indexOf(" ") + 1)
        : null;
    },
    // Method is use for convert base64 file into file
    createImageFromBase(dataUrl, filename) {
      var arr = dataUrl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    downloadWithAxios(url, title) {
      if (url == null) {
        return Middleware.notification("QR code not found !!", "danger");
      }
      Axios({
        url: url,
        method: "get",
        responseType: "blob",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", title);
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => console.log("error occur"));
    },
  },
};
</script>

<template>
  <div>
    <b-form @submit.prevent="onSubmit">
      <!-- Section is holding loading -->
      <div class="row" v-if="isLoading">
        <div class="col-lg-12">
          <b-card>
            <b-card-text>
              <div class="row">
                <div class="col-12">
                  <b-card-title>
                    <h4 class="card-title">General Details</h4>
                  </b-card-title>
                  <hr />
                </div>
              </div>
              <div class="row">
                <div
                  class="col-md-4 placeholder-glow"
                  v-for="no in 3"
                  :key="no"
                >
                  <span class="placeholder w-100"></span>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <b-card-title>
                    <h4 class="card-title">Address Details</h4>
                  </b-card-title>
                  <hr />
                </div>
              </div>
              <div class="row">
                <div class="col-md-8 placeholder-glow">
                  <span class="placeholder w-100 p-4"></span>
                </div>
                <div class="col-md-4 placeholder-glow">
                  <span class="placeholder w-100"></span>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-md-4 placeholder-glow"
                  v-for="no in 3"
                  :key="no"
                >
                  <span class="placeholder w-100"></span>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <b-card-title>
                    <h4 class="card-title">Contact Details</h4>
                  </b-card-title>
                  <hr />
                </div>
              </div>
              <div class="row">
                <div
                  class="col-md-3 placeholder-glow"
                  v-for="no in 8"
                  :key="no"
                >
                  <span class="placeholder w-100"></span>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <b-card-title>
                    <h4 class="card-title">Time Related Information</h4>
                  </b-card-title>
                  <hr />
                </div>
              </div>
              <div class="row">
                <div
                  class="col-md-4 placeholder-glow"
                  v-for="no in 6"
                  :key="no"
                >
                  <span class="placeholder w-100"></span>
                </div>
              </div>

              <div class="row mt-4">
                <div class="col-12">
                  <b-card-title>
                    <h4 class="card-title">Additional Details</h4>
                  </b-card-title>
                  <hr />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 placeholder-glow">
                  <span class="placeholder w-100 h-200"></span>
                </div>
                <div class="col-md-6 placeholder-glow">
                  <span class="placeholder w-100 h-200"></span>
                </div>
                <div class="col-md-4 placeholder-glow mt-2">
                  <span class="placeholder w-25 p-3"></span>
                </div>
              </div>
            </b-card-text>
          </b-card>
        </div>
      </div>

      <!-- section is holding actual data -->
      <div class="row" v-else>
        <div class="col-lg-12">
          <b-card>
            <b-card-text>
              <!-- Hotel Information -->
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-2">
                      <h4 class="card-title mb-0">Hotel Information</h4>
                    </div>
                    <div class="col-md-8">
                      <h5
                        class="text-center text-uppercase text-primary cursor mb-0"
                      >
                        {{ hotel_fields.property_code }}
                        <i
                          class="fas fa-copy fs-4 ms-1"
                          @click="copyCode(hotel_fields.property_code)"
                        ></i>
                        <i
                          class="fas fa-qrcode fs-4 ms-2"
                          v-b-popover.hover="'Click to download QR Code'"
                          @click.prevent="
                            downloadWithAxios(
                              hotel_fields.property_qrcode,
                              'hotel_qr_code.png'
                            )
                          "
                        >
                        </i>
                      </h5>
                    </div>
                  </div>
                  <hr />
                </div>
                <div class="col-md-4">
                  <b-form-group class="mb-3" label-for="hotel-name-input">
                    <span slot="label">
                      Name <span class="text-danger">*</span>
                    </span>
                    <b-form-input
                      id="hotel-name-input"
                      type="text"
                      autocomplete="off"
                      v-model="hotel_fields.name"
                      :class="{
                        'is-invalid': submitted && $v.hotel_fields.name.$error,
                      }"
                    ></b-form-input>
                    <div
                      v-if="submitted && $v.hotel_fields.name.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.hotel_fields.name.required"
                        >Name is required.</span
                      >
                    </div>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group class="mb-3" label-for="brand-input">
                    <span slot="label">
                      Brand <span class="text-danger">*</span>
                    </span>
                    <b-form-input
                      id="brand-input"
                      type="text"
                      autocomplete="off"
                      v-model="hotel_fields.brand"
                      disabled
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group
                    class="mb-3 form-label"
                    id="input-group-1"
                    label-for="currency-input"
                  >
                    <span slot="label">
                      Currency <span class="text-danger">*</span>
                    </span>
                    <b-form-select
                      class="form-select"
                      id="currency-input"
                      type="text"
                      autocomplete="off"
                      v-model="hotel_fields.currency"
                      :options="currency"
                    >
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>
              <!-- Address Details -->
              <div class="row">
                <div class="col-md-12 mt-3">
                  <b-card-title>
                    <h4 class="card-title">Address Details</h4>
                  </b-card-title>
                  <hr />
                </div>
                <div class="col-md-8">
                  <b-form-group class="mb-3" label-for="address-input">
                    <span slot="label">
                      Address <span class="text-danger">*</span>
                    </span>
                    <b-form-textarea
                      id="address-input"
                      placeholder="Enter Address..."
                      v-model="hotel_fields.address"
                    ></b-form-textarea>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group class="mb-3" label-for="zip-code-input">
                    <span slot="label">
                      Zip Code <span class="text-danger">*</span>
                    </span>
                    <b-form-input
                      id="zip-code-input"
                      type="text"
                      autocomplete="off"
                      v-model="hotel_fields.zip_code"
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-4">
                  <b-form-group class="mb-3" label-for="city-input">
                    <span slot="label">
                      City <span class="text-danger">*</span>
                    </span>
                    <b-form-input
                      id="city-input"
                      type="text"
                      autocomplete="off"
                      v-model="hotel_fields.city"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group class="mb-3" label-for="state-input">
                    <span slot="label">
                      State <span class="text-danger">*</span>
                    </span>
                    <b-form-input
                      id="state-input"
                      type="text"
                      autocomplete="off"
                      v-model="hotel_fields.state"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group class="mb-3" label-for="country-input">
                    <span slot="label">
                      Country <span class="text-danger">*</span>
                    </span>
                    <b-form-input
                      id="country-input"
                      type="text"
                      autocomplete="off"
                      v-model="hotel_fields.country"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <!-- Contact Details -->
              <div class="row mt-3">
                <div class="col-md-12">
                  <b-card-title>
                    <h4 class="card-title">Contact Details</h4>
                  </b-card-title>
                  <hr />
                </div>

                <div class="col-md-3">
                  <b-form-group
                    class="mb-3 form-label"
                    id="input-group-1"
                    label-for="email-input"
                  >
                    <span slot="label">
                      Email <span class="text-danger">*</span>
                    </span>
                    <b-form-input
                      id="email-input"
                      type="email"
                      autocomplete="off"
                      v-model="hotel_fields.email"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <label class="form-label">Phone</label>
                  <vue-tel-input
                    v-model="hotel_fields.phone_number"
                    autoFormat
                    :autoDefaultCountry="false"
                    :defaultCountry="hotel.phone_number_iso"
                    :dropdownOptions="{
                      showDialCodeInList: true,
                      showDialCodeInSelection: true,
                      showFlags: true,
                      width: '390px',
                      showSearchBox: true,
                    }"
                    @country-changed="
                      countryChange('phone_number', ...arguments)
                    "
                  ></vue-tel-input>
                </div>
                <div class="col-md-3">
                  <label class="form-label">Front Desk Tel</label>
                  <vue-tel-input
                    v-model="hotel_fields.front_desk_number"
                    autoFormat
                    :autoDefaultCountry="false"
                    :defaultCountry="hotel.front_desk_number_iso"
                    :dropdownOptions="{
                      showDialCodeInList: true,
                      showDialCodeInSelection: true,
                      showFlags: true,
                      width: '390px',
                      showSearchBox: true,
                    }"
                    @country-changed="
                      countryChange('front_desk_number', ...arguments)
                    "
                  ></vue-tel-input>
                </div>
                <div class="col-md-3">
                  <label class="form-label">Whatsapp No</label>
                  <vue-tel-input
                    v-model="hotel_fields.whatsapp_number"
                    autoFormat
                    :autoDefaultCountry="false"
                    :defaultCountry="hotel.whatsapp_number_iso"
                    :dropdownOptions="{
                      showDialCodeInList: true,
                      showDialCodeInSelection: true,
                      showFlags: true,
                      width: '390px',
                      showSearchBox: true,
                    }"
                    :validCharactersOnly="true"
                    mode="auto"
                    @country-changed="
                      countryChange('whatsapp_number', ...arguments)
                    "
                  ></vue-tel-input>
                </div>
                <div disabled class="col-md-3">
                  <label class="form-label">SMS No</label>
                  <vue-tel-input
                    v-if="hotel_fields.is_bulk_vs_sms_enable"
                    v-model="hotel_fields.sms_number"
                    autoFormat
                    disabled
                    :autoDefaultCountry="false"
                    :defaultCountry="hotel.sms_number_iso"
                    :dropdownOptions="{
                      showDialCodeInList: true,
                      showDialCodeInSelection: true,
                      showFlags: true,
                      width: '390px',
                      showSearchBox: true,
                    }"
                    @country-changed="countryChange('sms_number', ...arguments)"
                  ></vue-tel-input>
                  <input
                    v-else
                    class="d-flex form-control"
                    disabled
                    type="text"
                    value="Service Disabled"
                  />
                </div>
                <div class="col-md-3">
                  <b-form-group
                    class="mb-3 form-label"
                    id="input-group-1"
                    label-for="website-input"
                  >
                    <span slot="label"> Website </span>
                    <b-form-input
                      id="website-input"
                      type="text"
                      autocomplete="off"
                      v-model="hotel_fields.website"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group
                    class="mb-3 form-label"
                    id="input-group-1"
                    label-for="date-time-formate-input"
                  >
                    <span slot="label"> Rewards Website </span>
                    <b-form-input
                      id="rewards-website-input"
                      type="text"
                      autocomplete="off"
                      v-model="hotel_fields.rewards_website_url"
                      disabled
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group
                    class="mb-3 form-label"
                    id="input-group-1"
                    label-for="date-time-formate-input"
                  >
                    <span slot="label"> Join Rewards Website </span>
                    <b-form-input
                      id="join-rewards-website-input"
                      type="text"
                      autocomplete="off"
                      v-model="hotel_fields.rewards_website_join_url"
                      disabled
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <!-- Time Related Information -->
              <div class="row mt-3">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-2">
                      <h4 class="card-title mb-0">Time Related Information</h4>
                    </div>
                  </div>
                  <hr />
                </div>

                <div class="col-md-3">
                  <b-form-group
                    class="mb-3 form-label"
                    id="input-group-1"
                    label-for="time-zone-input"
                  >
                    <span slot="label">
                      Time Zone <span class="text-danger">*</span>
                    </span>
                    <b-form-select
                      class="form-select"
                      id="time-zone-input"
                      :options="time_zones"
                      v-model="hotel_fields.time_zone"
                      type="text"
                      autocomplete="off"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group
                    class="mb-3 form-label"
                    id="input-group-1"
                    label-for="date-formate-input"
                  >
                    <span slot="label">
                      Date Format <span class="text-danger">*</span>
                    </span>
                    <b-form-select
                      class="form-select"
                      id="date-formate-input"
                      :options="date_formate"
                      v-model="hotel_fields.date_format"
                      type="text"
                      autocomplete="off"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group
                    class="mb-3 form-label"
                    id="input-group-1"
                    label-for="date-formate-input"
                  >
                    <span slot="label">
                      Time Format <span class="text-danger">*</span>
                    </span>
                    <b-form-select
                      class="form-select"
                      id="date-formate-input"
                      :options="time_formate"
                      v-model="hotel_fields.time_format"
                      type="text"
                      autocomplete="off"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group
                    class="mb-3 form-label"
                    id="input-group-1"
                    label-for="date-time-formate-input"
                  >
                    <span slot="label">
                      Date Time Format <span class="text-danger">*</span>
                    </span>
                    <b-form-select
                      class="form-select"
                      id="date-time-formate-input"
                      :options="date_time_formate"
                      v-model="hotel_fields.date_time_format"
                      type="text"
                      autocomplete="off"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group class="mb-3" label-for="check-in-time-input">
                    <span slot="label">
                      Check In Time <span class="text-danger">*</span>
                    </span>
                    <date-picker
                      lang="en"
                      placeholder="HH:mm"
                      v-model="hotel_fields.check_in_time"
                      type="time"
                      value-type="HH:mm"
                      :clearable="false"
                      :timePickerOptions="{
                        start: '00:00:00',
                        step: '00:15:00',
                        end: '23:30:00',
                        format: 'HH:mm',
                      }"
                    ></date-picker>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group class="mb-3" label-for="check-out-time-input">
                    <span slot="label">
                      Check Out Time <span class="text-danger">*</span>
                    </span>
                    <date-picker
                      lang="en"
                      placeholder="HH:mm"
                      v-model="hotel_fields.check_out_time"
                      type="time"
                      value-type="HH:mm"
                      :clearable="false"
                      :timePickerOptions="{
                        start: '00:00:00',
                        step: '00:15:00',
                        end: '23:30:00',
                        format: 'HH:mm',
                      }"
                    ></date-picker>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group
                    class="mb-3"
                    label-for="early-check-in-time-input"
                  >
                    <span slot="label"> Early Check In time </span>
                    <date-picker
                      lang="en"
                      placeholder="HH:mm"
                      v-model="hotel_fields.early_check_in_time"
                      type="time"
                      value-type="HH:mm"
                      :clearable="false"
                      :timePickerOptions="{
                        start: '00:00:00',
                        step: '00:15:00',
                        end: '23:30:00',
                        format: 'HH:mm',
                      }"
                    ></date-picker>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group
                    class="mb-3"
                    label-for="late-checkout-time-input"
                  >
                    <span slot="label"> Late Check Out Time </span>
                    <date-picker
                      lang="en"
                      placeholder="HH:mm:ss"
                      v-model="hotel_fields.late_check_out_time"
                      type="time"
                      :clearable="false"
                      value-type="HH:mm:ss"
                      :timePickerOptions="{
                        start: '00:00:00',
                        step: '00:15:00',
                        end: '23:30:00',
                        format: 'HH:mm',
                      }"
                    ></date-picker>
                  </b-form-group>
                </div>
              </div>
              <!-- Additional Details -->
              <div class="row mt-4">
                <div class="col-md-12">
                  <b-card-title>
                    <h4 class="card-title">Additional Details</h4>
                  </b-card-title>
                  <hr />
                </div>

                <div class="col-md-6">
                  <label for="logo" class="form-label">Logo</label>
                  <VueDropify
                    v-if="logo.imgURL == ''"
                    @upload="changeLogo($event)"
                    :src="logo.url ? logo.url : ''"
                    message="Drop image here or click to select"
                    class="w-100"
                  />
                  <vue-cropper
                    v-else
                    ref="cropper"
                    :src="logo.imgURL"
                    alt="Source Image"
                    class="position-relative w-100"
                    :minCropBoxWidth="200"
                    :minCropBoxHeight="200"
                  >
                  </vue-cropper>
                </div>
                <div class="col-md-6">
                  <label for="favicon" class="form-label">Favicon</label>
                  <VueDropify
                    v-if="favicon_icon.imgURL == ''"
                    @upload="changeFavicon($event)"
                    :src="favicon_icon.url ? favicon_icon.url : ''"
                    message="Drop image here or click to select"
                  />
                  <vue-cropper
                    v-else
                    ref="cropper"
                    :src="favicon_icon.imgURL"
                    alt="Source Image"
                    class="position-relative w-100"
                    :minCropBoxWidth="200"
                    :minCropBoxHeight="200"
                  >
                  </vue-cropper>
                </div>
                <div class="col-md-2">
                  <div class="d-flex align-items-center mt-3">
                    <b-form-input
                      class="form-control-color me-2"
                      id="theam_color"
                      type="color"
                      name="theam_color"
                      v-model="hotel_fields.app_theme_color"
                    ></b-form-input>

                    <b-form-input
                      class="form-control-color form-color-input"
                      id="theam_color"
                      type="text"
                      v-model="hotel_fields.app_theme_color"
                    ></b-form-input>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mt-3">
                    <b-form-group class="mb-3" id="theam_color_text_lable">
                    </b-form-group>
                  </div>
                </div>
              </div>
              <!-- Error Related -->
              <b-alert v-if="isError" show variant="danger">
                <ul>
                  <li v-for="(error, index) in errorMessage" :key="index">
                    {{ index }}: {{ error[0] }}
                  </li>
                </ul>
              </b-alert>
              <b-button
                variant="primary"
                class="float-end"
                type="submit"
                :class="{ disabled: isBtnLoading }"
              >
                <i
                  class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                  v-if="isBtnLoading"
                ></i>
                Update
              </b-button>
            </b-card-text>
          </b-card>
        </div>
      </div>
    </b-form>
  </div>
</template>

<style>
.form-color-input {
  width: 100px;
}
</style>
